<!-- Budget Details -->
<div *ngIf="budget" fxLayout="row" fxLayoutAlign="stretch">
  <mat-card [fxFlex.lt-xl]="35" [fxFlex.lt-md]="60">
    <mat-card-title>
      <ng-container *ngIf="budget.project && budget.project.internal && !budget.project.promo">
        <span class="budget_number">Internal</span>
        <span class="pipe-separator"></span>
      </ng-container>
      <ng-container *ngIf="budget.project && budget.project.promo">
        <span class="budget_number">Promo</span>
        <span class="pipe-separator"></span>
      </ng-container>
      <ng-container *ngIf="budget.project">
        <span class="budget_number">{{ budget.project.projectNr }}</span>
        <span class="pipe-separator"></span>
      </ng-container>
      <span class="budget_number">{{ budget.budgetNr }}</span>
      <span class="pipe-separator"></span>
      <span class="opp_name">{{ budget.prosperworks?.name }}</span>
      <span class="pipe-separator"></span>
      <span class="opp_company_name">{{ budget.prosperworks?.company_name }}</span>
      <span class="pipe-separator"></span>
      <a class="driveFolderLink" [href]="budgetFolderLink" target="_blank" i18n>Go to Folder</a>
    </mat-card-title>
    <mat-card-subtitle>
      <span class="opp_detail">{{ budget.description }}</span>
      <span class="opp_detail">{{ budget.prosperworks?.detail }}</span>
    </mat-card-subtitle>
    <mat-card-content>
      <div class="definition-list-container">
        <dl>
          <ng-container *ngIf="budget.assignee && budget.assignee.on">
            <dt i18n>Assigned on</dt>
            <dd>{{ budget.assignee?.on | date }}</dd>
          </ng-container>
          <ng-container *ngIf="budget.deliveryThr">
            <dt i18n>To be delivered</dt>
            <dd>{{ budget.deliveryThr | date }}</dd>
          </ng-container>
        </dl>
      </div>
      <div class="definition-list-container">
        <dl>
          <ng-container *ngIf="budget.author">
            <dt i18n>Author</dt>
            <dd>{{ budget.author?.displayName }}</dd>
          </ng-container>
          <ng-container *ngIf="budget.creation">
            <dt i18n>Created on</dt>
            <dd>{{ budget.creation|date }}</dd>
          </ng-container>
          <ng-container *ngIf="budget.offerDate">
            <dt i18n>Offer Date</dt>
            <dd>{{ budget.offerDate |date }}</dd>
          </ng-container>
          <ng-container *ngIf="budget.budgetAmount">
            <dt i18n>Budget Amount</dt>
            <dd>{{ budget.budgetAmount| currency:'EUR' }}</dd>
          </ng-container>
          <ng-container *ngIf="budget.budgetCostTotal">
            <dt i18n>Cost tot.</dt>
            <dd>{{ budget.budgetCostTotal| currency:'EUR' }}</dd>
          </ng-container>
          <ng-container *ngIf="budget.budgetHoursTotal">
            <dt i18n>Hours tot.</dt>
            <dd>{{ budget.budgetHoursTotal| currency:'EUR' }}</dd>
          </ng-container>
          <ng-container *ngIf="budget.budgetMaterialsTotal">
            <dt i18n>Material tot.</dt>
            <dd>{{ budget.budgetMaterialsTotal| currency:'EUR' }}</dd>
          </ng-container>
          <ng-container *ngIf="budget.projectManager">
            <dt i18n>Project Manager</dt>
            <dd>{{ budget.projectManager }}</dd>
          </ng-container>
          <ng-container *ngIf="budget.ref">
            <dt i18n>Ref</dt>
            <dd>{{ budget.ref }}</dd>
          </ng-container>
          <ng-container *ngIf="budget.salesManager">
            <dt i18n>Sales Manager</dt>
            <dd>{{ budget.salesManager }}</dd>
          </ng-container>
          <ng-container *ngIf="exportBudget">
            <dt i18n>Export</dt>
            <dd>{{ exportBudget.budgetNr }}</dd>
          </ng-container>
          <ng-container *ngIf="budget.export && budget.export.from">
            <dt i18n>Import</dt>
            <dd>
              <a [routerLink]="['/budget',budget.export.from.id ]">{{ budget.export.from.budgetNr }}</a>
            </dd>
          </ng-container>
        </dl>

      </div>
      <div class="offer-block">
        <div *ngIf="this.poCreating">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        <div *ngIf="this.offerUrl">
          <span class="inline-label" i18n>Offer</span>
          <span>
            <a [href]="this.offerUrl" target="_blank">{{ this.offerUrl }}</a>
          </span>
        </div>
        <div *ngIf="exportBudget && exportBudget.offerUrl">
          <span class="inline-label" i18n>Export Offer</span>
          <span>
            <a [href]="exportBudget.offerUrl" target="_blank">{{ exportBudget.offerUrl }}</a>
          </span>
        </div>
      </div>
      <div class="button-row">
        <button *ngIf="canAssignBudget && budget.status && budget.status === 'new'" mat-raised-button (click)="openDialog()" i18n>Assign</button>
        <!-- <button *ngIf="isEditable" mat-raised-button (click)="prepareOffer()" [disabled]="this.poCreating" i18n>Prepare Offer</button> -->
        <button *ngIf="isEditable && !budget.export" mat-raised-button [matMenuTriggerFor]="offerMenu" [disabled]="this.poCreating" i18n>Prepare Offer</button>
        <mat-menu #offerMenu="matMenu">
          <button *ngFor="let t of offerTemplates" mat-menu-item (click)="prepareOffer(t)">{{ t.name }}</button>
        </mat-menu>

        <button *ngIf="budget.status && budget.status === 'archived'" mat-raised-button (click)="getReportFile()" i18n>Send me Report file</button>

        <!-- Wizard Button - Hidden fot later deploy -->
        <button *ngIf="false" mat-raised-button (click)="openOfferWizard()" [disabled]="this.poCreating" i18n>Create offer document</button>
        <!-- End Wizard Button -->

        <!-- <button mat-raised-button (click)="prepareOfferWithTemplate()" i18n>Create offer data</button> -->

        <button *ngIf="exportBudget && exportBudget.status != 'closed' && offerExportTemplates" mat-raised-button [matMenuTriggerFor]="offerExportMenu" [disabled]="this.poCreating" i18n>Export Offer</button>
        <mat-menu #offerExportMenu="matMenu">
          <button *ngFor="let t of offerExportTemplates" mat-menu-item (click)="prepareExportOffer(t)">{{ t.name }}</button>
        </mat-menu>

        <!-- <button mat-raised-button (click)="sendOffer()" [disabled]="this.poCreating" i18n>Send Offer</button> -->
        <button *ngIf="budget.status && budget.status !== 'new' && isEditable && canOpenProject" mat-raised-button (click)="openProject()" [disabled]="this.poCreating" i18n>Open Project</button>

        <button *ngIf="canArchiveProject && budget.status !== 'archived'" mat-raised-button (click)="archive()" [disabled]="this.poCreating" i18n>Archive Project</button>
        
        <!-- Import from sheet button - Hidden for later deploy -->
        <button *ngIf="false" mat-raised-button [disabled]="importingBoM" (click)="importFromSheet($event)" i18n>Import BoM</button>
        <!-- End import from sheet button -->

        
        <!-- change status menu -->
        <!--
        <mat-menu #appMenu="matMenu">
          <button mat-menu-item (click)="setStatus('new')">New</button>
          <button mat-menu-item (click)="setStatus('edit')">Edit</button>
          <button mat-menu-item (click)="setStatus('closed')">Closed</button>
        </mat-menu>


        <button *ngIf="canChangeStatus" mat-raised-button [matMenuTriggerFor]="appMenu">Change Status</button>
      -->
        <button *ngIf="createExportBudgetBtn" mat-raised-button (click)="createExportBudget()" i18n>Generate Export</button>
        <button *ngIf="removeExportLinkBtn" mat-raised-button (click)="removeExportLink()" i18n>Remove export link</button>
        <mat-form-field>
            <mat-select placeholder="Filter" multiple [(ngModel)]="tagFilter" (change)="filterChange()">
              <mat-option *ngFor="let tag of tags$ | async" [value]="tag">{{tag}}</mat-option>
            </mat-select>
          </mat-form-field>
      </div>
      <div *ngIf="!budget.status">
        <p class="warn-message" i18n>
          This budget cannot be edited because his status is unknown. Please assign a status to this budget using the "Change Status" button
        </p>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-card *ngIf="canSeeFigures && !budget.export" [fxFlex.lt-xl]="25" [fxFlex.lt-md]="40" class="total-summary-card">
    <table *ngIf="budget.costSummary">
      <tr>
        <td class="inline-label" i18n>Total Cost</td>
        <td>{{ budget.costSummary.total | currency:'EUR':'symbol':'1.0-0' }}</td>
      </tr>
      <tr>
        <td class="inline-label" i18n>Total Offer</td>
        <td>{{ oData?.offerAmount | currency:'EUR':'symbol':'1.0-0' }}</td>
      </tr>
      <ng-template [ngIf]="budget.exportBudget">
        <tr>
          <td class="inline-label" i18n>Total Cost USA</td>
          <td>{{ exportBudget?.costSummary?.total | currency:'EUR':'symbol':'1.0-0' }} ({{ exportBudget?.costSummary?.total * exportBudget?.export?.exchangeRate | currency:'USD':'symbol':'1.0-0' }})</td>
        </tr>
        <tr>
          <td class="inline-label" i18n>Total Offer USA</td>
          <td>{{ oDataExport?.offerAmount | currency:'USD':'symbol':'1.0-0' }}</td>
        </tr>
      </ng-template>
      <tr *ngIf="budget.project">
        <td class="inline-label" i18n>Final Offer</td>
        <td *ngIf="!budget.exportBudget">{{ budget.project.finalOfferOrder | currency:'EUR':'symbol':'1.0-0' }}</td>
        <td *ngIf="budget.exportBudget">{{ budget.project.finalOfferOrder | currency:'USD':'symbol':'1.0-0' }}</td>
      </tr>
    </table>
    <br />
    <table *ngIf="budget.project && budget.prosperworks && !budget.project.internal && cosmoEnabled">
      <tr>
        <td class="inline-label" i18n>Payment Status</td>
        <td *ngIf="!budget.paymentStatus">
          <mat-progress-spinner mode="indeterminate" [diameter]="30" class="spinner-progress"></mat-progress-spinner>
        </td>
        <td *ngIf="budget.paymentStatus">{{ budget.paymentStatus?.completion }}%</td>
      </tr>
    </table>
    <table *ngIf="budget.project && budget.prosperworks && !budget.project.internal && budget.paymentStatus && budget.paymentStatus.errors.length > 0 && cosmoEnabled">
      <tr>
        <td><span i18n class="errorMessage">{{ budget.paymentStatus.errors }}</span></td>
      </tr>
    </table>
    <button mat-mini-fab (click)="getCostSummary($event)" [disabled]="totalRefreshDisabled" class="refresh-button">
      <mat-icon>refresh</mat-icon>
    </button>
  </mat-card>
  <mat-card [fxFlex.lt-xl]="40" fxShow.lt-md="false" class="chart-summary-card">
      <app-summary-chart [data]="subBudgetValuesForChart"></app-summary-chart>
  </mat-card>
</div>
<mat-tab-group *ngIf="budget">
  <mat-tab *ngIf="canSeeFigures" label="Summary">
    <ng-template mat-tab-label>
      <b i18n>Summary</b>
    </ng-template>
    <div fxLayout="row">
      <mat-card style="flex:1 1 15%">
        <app-margin-form [budget]="budget"></app-margin-form>
      </mat-card>
      <mat-card *ngIf="!budget.export" style="flex:1 1 15%">
        <app-assemblyCosts-form [budget]="budget"></app-assemblyCosts-form>
      </mat-card>
      <mat-card style="flex:3 1 55%">
        <mat-table #table [dataSource]="budgetDataSource">
          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> Desc </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="cost">
            <mat-header-cell *matHeaderCellDef i18n>Cost</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.cost | number:'1.2-2' }}</mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="profit">
            <mat-header-cell *matHeaderCellDef i18n>Profit</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.profit | number:'1.2-2' }}</mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="expenses">
            <mat-header-cell *matHeaderCellDef i18n>Gen. Expenses</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.expenses | number:'1.2-2' }}</mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="commission">
            <mat-header-cell *matHeaderCellDef i18n>Commission</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.commission | number:'1.2-2' }}</mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="customDuties">
            <mat-header-cell *matHeaderCellDef i18n>Customs</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.customDuties | number:'1.2-2' }}</mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="total">
            <mat-header-cell *matHeaderCellDef i18n>Total </mat-header-cell>
            <mat-cell *matCellDef="let element">{{element.total | number:'1.2-2' }}</mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="totalCurrency">
            <mat-header-cell *matHeaderCellDef i18n>Total (USD)</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.totalCurrency | currency:'USD' }}</mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="budgetDisplayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: budgetDisplayedColumns;"></mat-row>
        </mat-table>
      </mat-card>
    </div>
  </mat-tab>
  <mat-tab *ngIf="exportBudget && canSeeFigures" label="Summary USA">
    <ng-template mat-tab-label>
      <b i18n>Summary USA</b>
    </ng-template>
    <div fxLayout="row">
      <div fxLayout="row" fxFlex="1 1 40%">
        <mat-card fxFlex="1 1 30%">
          <app-margin-form [budget]="exportBudget"></app-margin-form>
        </mat-card>
        <mat-card fxFlex="1 1 30%">
          <app-assemblyCosts-form [budget]="exportBudget"></app-assemblyCosts-form>
        </mat-card>
        <mat-card fxFlex="1 1 30%">
          <app-export-form [budget]="exportBudget"></app-export-form>
        </mat-card>
      </div>
      <mat-card fxFlex="1 1 60%">

        <mat-table #table [dataSource]="exportBudgetDataSource">


          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef> Desc </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
          </ng-container>

          <!-- Weight Column -->
          <ng-container matColumnDef="cost">
            <mat-header-cell *matHeaderCellDef i18n>Cost</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.cost | number:'1.2-2' }} </mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="profit">
            <mat-header-cell *matHeaderCellDef i18n>Profit</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.profit | number:'1.2-2' }} </mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="expenses">
            <mat-header-cell *matHeaderCellDef i18n>Gen. Expenses</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.expenses | number:'1.2-2' }} </mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="commission">
            <mat-header-cell *matHeaderCellDef i18n>Commission</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.commission | number:'1.2-2' }} </mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="customDuties">
            <mat-header-cell *matHeaderCellDef i18n>Customs</mat-header-cell>
            <mat-cell *matCellDef="let element">{{ element.customDuties | number:'1.2-2' }}</mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="total">
            <mat-header-cell *matHeaderCellDef i18n>Total </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.total | number:'1.2-2' }} </mat-cell>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="totalCurrency">
            <mat-header-cell *matHeaderCellDef i18n>Total (USD)</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{ element.totalCurrency | currency:'USD' }} </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="exportBudgetDisplayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: exportBudgetDisplayedColumns;"></mat-row>
        </mat-table>

      </mat-card>
    </div>
  </mat-tab>
  <ng-container *ngFor="let sb of sbColl | async; index as i"  >
    <mat-tab *ngIf="checkFilters(sb.tags)" [label]="sb.description">
      <ng-template  mat-tab-label>
        <span [class]="sb.calculate? '' :'mat-label-disabled'">
          {{ sb.description }}&nbsp;
          <mat-icon *ngIf="sb.report">timer</mat-icon>
          <mat-icon *ngIf="sb.overrideEdit">whatshot</mat-icon>
        </span>
      </ng-template>
      <app-sub-budget [budgetTotal]="budgetTotalCost" [budget]="budget" [subBudgetId]="sb.id" (tagsUpdated)="toggleCalculate($event,sb)" (delete)="deleteSubBudget($event)" (update)="updateSubBudgetValues($event, sb.id)"></app-sub-budget>
    </mat-tab>
  </ng-container>
  <!-- Add a new subBudget -->
  <mat-tab *ngIf="!budget.export && canAddSubBudget && !(budget.status === 'archived')" label="Add New...">
    <mat-card>
      <app-sub-budget-form (onSubmit)="addSubBudget($event)"></app-sub-budget-form>
    </mat-card>
  </mat-tab>
</mat-tab-group>
<div *ngIf="!budget" fxLayout="column">
  <mat-progress-spinner fxLayoutAlign="center center"></mat-progress-spinner>
</div>



// WEBPACK FOOTER //
// ./src/app/budget/budget-detail.component.html